import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppComponent } from "../../app.component";
import { AuthenticationService } from "../../services/authentication.service";
import { UserDataStoreService } from "../../services/user-data-store.service";
import { Observable, Subscription, Subject } from "rxjs";
import { LoggedInUser } from "../../models/user";
import { ParticipantViewModel } from '../../models/participant-view-model';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Router } from "@angular/router";
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit, OnDestroy {

  public currentUser: Observable<LoggedInUser>;
  public participants: ParticipantViewModel[];
  public selectedParticipant: number;
  public selectedParticipantName: string;
  private subscription: Subscription;
  public dtTrigger: Subject<boolean> = new Subject();


  constructor(private rootApp: AppComponent,
    private _router: Router,
    private _authenticationService: AuthenticationService,
    private _userDataStore: UserDataStoreService,
    private ngxLoader: NgxUiLoaderService) {

    this.currentUser = _userDataStore.currentUser
    this.participants = this._userDataStore.userParticipants;
    this.selectedParticipant = this._userDataStore.selectedParticipant?.id;
    this.subscription = this._userDataStore.selectedParticipantObservable.subscribe(async () => {
      await this.init();
    });

  }

  private async init(): Promise<void> {
    setTimeout(() => {
      if (this._userDataStore.selectedParticipant != null) {
        this.selectedParticipantName = this._userDataStore.selectedParticipant.name;
        this.selectedParticipant = this._userDataStore.selectedParticipant.id;

      }
    }, 1000);
    this.dtTrigger.next();
  }

  ngOnInit() {
  }

  public openMenu() {
    if (!!environment.topBarCssVariable) {
      this.rootApp.cssClass = this.rootApp.cssClass = `${environment.topBarCssVariable} right-bar-enabled`;
    } else {
      this.rootApp.cssClass = this.rootApp.cssClass = 'right-bar-enabled';
    }
  }

  public expandNotifications() {

  }


  public logout(): void {
    this._authenticationService.logout();
  }

  public async navigateUserProfile(): Promise<void> {
    await this._router.navigate(['./user-profile']);
  }

  public async navigatePasswordReset(): Promise<void> {
    await this._router.navigate(['./reset-password']);
  }

  public async onChange(): Promise<void> {
    this.ngxLoader.start();
    //this.closeMenu();
    await this._authenticationService.refreshSession(this.participants.find(x => x.id == this.selectedParticipant).id);
    //await this._router.navigate(['']);
    this.ngxLoader.stop();
  }

  public closeMenu() {
    if (!!environment.topBarCssVariable) {
      this.rootApp.cssClass = this.rootApp.cssClass = environment.topBarCssVariable;
    } else {
      this.rootApp.cssClass = this.rootApp.cssClass = '';
    }
  }


  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
    this.subscription.unsubscribe();
  }
}
